export const STRINGS = {
  GOOGLE_REGISTER:
    "  Sorry, the page you are looking doesn’t exist or has been moved.",
  ERROR: "Error 404",
};
